import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=3bc5f465&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=3bc5f465&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc5f465",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc5f465')) {
      api.createRecord('3bc5f465', component.options)
    } else {
      api.reload('3bc5f465', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=3bc5f465&scoped=true&", function () {
      api.rerender('3bc5f465', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RMAjWYr1z197/JS/comp/Voucher.vue"
export default component.exports